import React from 'react';
import ReactDOM from 'react-dom/client';
import styles from './PlusUpView.scss';
import classNames from 'classnames/bind';

import {NumericFormat} from 'react-number-format';
// import Adsense970250 from 'components/adsense/Adsense970250';
import Adsense300250 from 'components/adsense/Adsense300250';
import Adsense72890 from 'components/adsense/Adsense72890';

const cx = classNames.bind(styles);

const plusFilter = {
  'plusFilter1': [
    {filterName: '일반', name:'plusFilter1'},
    {filterName: '원피스', name:'plusFilter1'},
    {filterName: '변이', name:'plusFilter1'}
  ],
  'plusFilter2': [
    {filterName: '장인', name:'plusFilter2'},
    {filterName: '명인', name:'plusFilter2'},
    {filterName: 'O.T', name:'plusFilter2'}
  ],
  'plusFilter3': new Array(9).fill(0,0,9)
}

const pUpSucessList = {
  'list1': [],
  'list2': [],
  'list3': [],
  'list4': [],
  'list5': [],
  'list6': [],
  'list7': [],
  'list8': [],
  'list9': [],
  'list10': [],
  'list11': [],
  'list12': [],
  'list13': [],
  'list14': [],
  'list15': []
}

const pUpPtclRender = (cnt) => {
  const pUpdtlUl = ReactDOM.createRoot(
    document.getElementById('pUpdtlUl')
  );

  // count: sCnt,
  // curPup: curPup,
  // goalPup: goalPup,
  // isSucess: isSucess,
  // pUpCnt: pUpCnt

  const list = pUpSucessList[`list${cnt}`].map((obje, cnt) => {
    const {count, isSucess, procRvn, curPup, beforePup} = obje;

    return (
      <li key={cnt}>
        <div>
          <NumericFormat value={count} displayType={'text'} 
          thousandSeparator={true} suffix={'번째 '}/>
          {procRvn}% 확률로 <b>{isSucess}</b> {beforePup}→{curPup}
        </div>
        {/* <div> </div>
        <div> 
          카모지 
        </div>
        <div>
        
        </div> */}
          {/* 1번째시도 성공<span style={{fontSize:'20px'}}>🤩</span></div>
        <li>1번째시도 실패(초기화)<span style={{fontSize:'20px'}}>🤪</span> 8→0 4,433,800</li>
      <li>1번째시도 실패🤪 (유지) 5→5 4,433,800 */}

      </li>
    )
  });

  pUpdtlUl.render(list);
}

//plusUPGrid 1tier(0:일반,1:원피스,2:변이) 2tier(0:장인,1:명인,2:OT)
//3tier (0:3급~8:11급) 4tier (0:1플~14:15플)
//CL은 최종값의 (plusup*1.1).toFixed(2)


const PlusUpView = ({plusUpGrid, onChangePlusFilter, plsuUpNoti, plusUpLuck, plusUpRandom, ctrlReCalc}) => {
  const plusUpLuckList = plusUpLuck.map(luck => {
    const {up, success, fail, failZero} = luck;

    return (
      <li className={cx('luck-object')} key={up}>
        <div className={cx('luck-object-up')}>+{up}</div>
        <div className={cx('luck-object-suc')}>성공:{success}%, </div>
        <div className={cx('luck-object-fail')}>실패:{fail}%, </div>
        <div className={cx('luck-object-failzero')}>초기화:{failZero}%</div>
      </li>
    )
  });
  const plusFilterRender = (flag) => {
    const plusFilterTemp = plusFilter[`plusFilter${flag}`];
    const checkValue = plsuUpNoti[`plusFilter${flag}`];

    const plusupFilterHtml = plusFilterTemp.map((filter, cnt) => {
      const {filterName, name} = filter;
      const isCheck = checkValue === String(cnt) ? true : false;

      return (
        <React.Fragment key={cnt}>
          <input type="radio" onChange={onChangePlusFilter} 
          id={`pFilter_check${flag+cnt}`} checked={isCheck}
          alt={flag === '3' ? `${cnt+3}급` : filterName} 
          name={flag === '3' ? 'plusFilter3' : name} value={cnt} />
          <label htmlFor={`pFilter_check${flag+cnt}`}>
            <span>{flag === '3' ? `${cnt+3}급` : filterName}</span>
          </label>
        </React.Fragment> 
      )
    });

    return plusupFilterHtml;
  }

  const {plusFilter1, plusFilter2, plusFilter3, plusUpKitPrice, plusUpKitPriceNor} = plsuUpNoti;
  const plusupList = plusUpGrid[Number(plusFilter1)][Number(plusFilter2)][Number(plusFilter3)];
  let needKitCntAppend = 0;
  const list = plusupList.map((dmg, cnt) => {
    const needKitCnt = Math.pow(2, cnt) * (plusFilter1 === '0' ? 1 : plusFilter1 === '1' ? 2 : 6);
    needKitCntAppend += needKitCnt;

    const kitTotPrice = Math.ceil(plusUpKitPrice*needKitCntAppend);
    const value = kitTotPrice > 100000000 ? (kitTotPrice/100000000).toFixed(2) : (kitTotPrice > 1000000 ? (kitTotPrice/1000000).toFixed(2) : kitTotPrice);
    const dv = kitTotPrice > 100000000 ? '억' : (kitTotPrice > 1000000 ? '백만' : '');

    return (
      <li>
        <div className={cx('plustier')}>{cnt+1}강</div>
        <div className={cx('kitctt')}>
          {/* 완플 비용/갯수 */}
          <NumericFormat value={needKitCntAppend} displayType={'text'} 
          thousandSeparator={true} suffix={'개'}/><br/><NumericFormat value={value} 
          displayType={'text'} thousandSeparator={true} suffix={dv}/>
        </div>
        <div className={cx('dmg-plusup-list-last')}>{dmg}%<br/>{(dmg*1.1).toFixed(2)}% (CL)</div>
      </li>
    )
  });

  const list1 = plusupList.map((dmg, cnt) => {
    // let pass = false;
    let pUpCnt = 0; //소모플업
    let sCnt = 0; //소모플업
    let goalPup = cnt + 1; //목표강화치
    let curPup = 0; //현재강화치
    let beforePup = 0; //이전강화치
    let pUpSucList = [];
    let isSucess = '';
    let procRvn = 0; //처리된결과의확률
    // const successRt = Number(plusUpLuck[cnt].luck.success) / 10; //성공확률
    

    // if(cnt < 8) {
    do {
      const {success, fail/*, failZero*/} = plusUpLuck[curPup].luck;
      const {success: sucRv, fail: failRv, failZero: zeroRv} = plusUpLuck[curPup];
      const goNumber = plusUpRandom(1000);

      sCnt += 1;
      pUpCnt += (plusFilter1 === '0' ? 1 : plusFilter1 === '1' ? 2 : 6);
      beforePup = curPup;

      if(goNumber <= Number(success)) {
        curPup += 1;
        isSucess = '성공';
        //console.log('성공');
        procRvn = sucRv;
      }else if(goNumber <= Number(fail)) {
        //유지
        //console.log('유지');
        isSucess = '유지';
        procRvn = failRv;
      }else{
        curPup = 0;
        isSucess = '초기화';
        procRvn = zeroRv;
        //console.log('실패');
      }
      // if(cnt===7) {
      // console.log('랜덤결과, 성공확률, 성공여부, 소요갯수, 현재강화, 목표강화');
      // console.log(goNumber, Number(success), goNumber <= Number(success), pUpCnt, curPup, goalPup);
      // }

      pUpSucList.push({
        count: sCnt,
        curPup: curPup,
        goalPup: goalPup,
        isSucess: isSucess,
        pUpCnt: pUpCnt,
        beforePup: beforePup,
        procRvn: procRvn
      });

      if(sCnt > 1000) pUpSucList.shift();

    } while (curPup !== goalPup);
    // }

    pUpSucessList[`list${goalPup}`] = pUpSucList;

    return (
      <li>
        <div className={cx('plustier')}>{cnt+1}강</div>
        <div className={cx('ctt')}>
          <NumericFormat value={sCnt} displayType={'text'} 
          thousandSeparator={true} suffix={'회 시도'}/>
          {/* <NumericFormat value={pUpCnt} displayType={'text'} 
          thousandSeparator={true} prefix={'('} suffix={'개)'}/> */}
          <br/>
          <NumericFormat value={pUpCnt*plusUpKitPriceNor} 
          displayType={'text'} thousandSeparator={true} />
        </div>
        <div className={cx('plusup-list-last')} onClick={() => pUpPtclRender(cnt+1)}>
          자세히보기
        </div>
      </li>
    )
  });

  return (
    <section className={cx('main-contents')}>
      <div className={cx('plusup-filter')}>
        <div className={cx('button-group')}>{plusFilterRender('1')}</div>
        <div className={cx('button-group')}>{plusFilterRender('2')}</div>
        <div className={cx('button-group')}>{plusFilterRender('3')}</div>
      </div>
      <div className={cx('plusup-text')}>
        완플가격 <input type="text" placeholder="" name='plusUpKitPrice' value={plusUpKitPrice} onChange={onChangePlusFilter} />
        &nbsp;&nbsp;일플가격 <input type="text" placeholder="" name='plusUpKitPriceNor' value={plusUpKitPriceNor} onChange={onChangePlusFilter} />
      </div>
      <Adsense72890/>
      <div className={cx('plusup-list')}>
        <span className={cx('plusup-title')}>
          플업강화별 공격력및 완벽한 플러스업 강화비용(원)
        </span>
        <ul>{list}</ul>
      </div>
      <Adsense300250/>
      <div className={cx('plusup-list')}>
        <span className={cx('plusup-title')}>
          {plusFilter['plusFilter1'][plusFilter1].filterName}의상
          플러스업 강화기대비용(원)
          <button className={cx('btn-re-calc')} onClick={ctrlReCalc}>다시계산</button>
        </span>
        <ul>{list1}</ul>
      </div>
      <div className={cx('plusup-list-dtl')}>
        <span className={cx('plusup-title')}>
          플업강화내역 자세히보기 (최근 1,000회치)
        </span>
        <ul id="pUpdtlUl">
          {/* <li>{JSON.stringify(pUpSucessList.list9)}</li> */}
        </ul>
      </div>
      <div className={cx('plusluck-list')}>
        <span className={cx('plusup-title')}>플업강화별 확률정보</span>
        <ul>{plusUpLuckList}</ul>
      </div>
      
    </section>
  );
}

export default PlusUpView;